import { NewUserFilled, ArrowRightThin } from '@ori-ui/icons';
import { Typography } from '@ori-ui/mui';
import { useDisclose } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';

import { useTopAreaBanner } from '../../context';
import { useTranslations } from '../../hooks/useTranslations';
import { OrderOnBehalfDialog } from './OrderOnBehalfDialog';
import { ORDER_ON_BEHALF } from './constants';
import { OrderContent, Username } from './styles';

export const OrderOnBehalf = () => {
  const { orderOnBehalfData } = useTopAreaBanner();
  const { VipAccessData: vipAccessData, VipAccessLabels: vipAccessLabels } = orderOnBehalfData ?? {};
  const { getTestId } = useTestId();
  const { open, onClose, onOpen } = useDisclose();
  const { translations } = useTranslations();

  if (!vipAccessData || !vipAccessLabels) {
    return null;
  }

  return (
    <OrderContent data-testid={getTestId(ORDER_ON_BEHALF)}>
      <NewUserFilled />
      <Typography>{translations.loggedInAs}</Typography>
      <Username onClick={onOpen}>{vipAccessData.ConsultantName}</Username>
      <OrderOnBehalfDialog
        open={open}
        close={onClose}
        vipAccessData={vipAccessData}
        vipAccessLabels={vipAccessLabels}
      />
      <ArrowRightThin />
    </OrderContent>
  );
};
